var map = {
	"./portfolio1.jpg": 305,
	"./portfolio2.jpg": 4454,
	"./portfolio3.jpg": 4563,
	"./portfolio5.jpg": 4301,
	"./portfolio6.jpg": 5074,
	"./portfolio7.jpg": 3135,
	"./portfolio8.jpg": 9036,
	"./portfolio9.jpg": 5913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4861;